/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteOrganizationRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type DeleteOrganizationRemoteSessionIssuerRequest = {
  /**
   * The remote_session_issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type DeleteOrganizationRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const DeleteOrganizationRemoteSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    DeleteOrganizationRemoteSessionIssuerSecurity$Outbound,
    DeleteOrganizationRemoteSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function deleteOrganizationRemoteSessionIssuerSecurityToJSON(
  deleteOrganizationRemoteSessionIssuerSecurity:
    DeleteOrganizationRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    DeleteOrganizationRemoteSessionIssuerSecurity$outboundSchema.parse(
      deleteOrganizationRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type DeleteOrganizationRemoteSessionIssuerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const DeleteOrganizationRemoteSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    DeleteOrganizationRemoteSessionIssuerRequest$Outbound,
    DeleteOrganizationRemoteSessionIssuerRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function deleteOrganizationRemoteSessionIssuerRequestToJSON(
  deleteOrganizationRemoteSessionIssuerRequest:
    DeleteOrganizationRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    DeleteOrganizationRemoteSessionIssuerRequest$outboundSchema.parse(
      deleteOrganizationRemoteSessionIssuerRequest,
    ),
  );
}
